var _g, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7523_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7826 9.7793H24.2713L18.8339 15.9944L25.231 24.4501H20.2224L16.2999 19.3211L11.8107 24.4501H9.32056L15.1367 17.8021L9 9.77997H14.1357L17.6815 14.468L21.7826 9.7793ZM20.9095 22.9609H22.2884L13.3864 11.1907H11.9067L20.9095 22.9609Z",
    fill: "#8E8E8E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6928,
    cy: 16.5385,
    r: 16.5385,
    fill: "#6C6C6C",
    fillOpacity: 0.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6928,
    cy: 16.5385,
    r: 16.125,
    stroke: "#8E8E8E",
    strokeOpacity: 0.31,
    strokeWidth: 0.826923
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7523_5991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.231,
    height: 16.231,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.55f382fa03052a4b7796f0d8b7438788.svg";
export { ForwardRef as ReactComponent };